import { hrRedirect, type FindingsFilters, type HrTarget } from './navigation';

/**
 * The old Health Check and Go-Live Readiness URLs (T-0224, E20 design §4;
 * mapped onto the tabs in T-0242, E22 design §1). Every one of them still
 * lands: its route's `beforeLoad` throws the redirect this module builds,
 * to the tab (and row) that shows what the old page showed. `replace`, so
 * Back skips the old URL instead of bouncing on it.
 *
 * A redirect that cannot know a row's id (the Budget and Schedule tabs)
 * carries a `domain-name:<name>` hint the Overview resolves against its
 * composite read, so no redirect fetches.
 */

export function redirectToHealthReadiness(engagementId: string, target: HrTarget) {
  return hrRedirect(engagementId, target);
}

const text = (v: unknown): string | undefined =>
  typeof v === 'string' && v.length > 0 ? v : undefined;

/**
 * `?domain=<id>` on the old overview and Domains tab named the open domain;
 * it becomes that domain's tab.
 */
export function legacyDomainSearch(s: Record<string, unknown>): { domain?: string } {
  const domain = text(s.domain);
  return domain ? { domain } : {};
}

/** The domain an old URL named, else `fallback` (the Overview or the Domains tab). */
export function domainTarget(search: { domain?: string }, fallback: HrTarget): HrTarget {
  return search.domain ? { tab: 'domains', id: search.domain } : fallback;
}

/** The old findings register kept its filters in the URL; they ride along. */
export function legacyFindingsSearch(s: Record<string, unknown>): FindingsFilters {
  const out: FindingsFilters = {};
  const severity = text(s.severity);
  const status = text(s.status);
  const domain = text(s.domain);
  if (severity) out.severity = severity;
  if (status) out.status = status;
  if (domain) out.domain = domain;
  return out;
}
